import { Ellipse, Polyline, Rect } from 'fabric';

export const DRAWING_TOOLS = Object.freeze({
	CLEAR: 'clear',
	ERASER: 'eraser',
	PENCIL: 'pencil',
	SHAPE: 'shape'
});

export const COLORS = Object.freeze({
	TRANSPARENT: 'transparent',
	WHITE: 'white',
	BLACK: 'black',
	INDIAN_RED: 'indianred',
	RED: 'red',
	ORANGE: 'orange',
	YELLOW: 'yellow',
	LAWN_GREEN: 'lawngreen',
	GREEN: 'green',
	CYAN: 'cyan',
	BLUE: 'blue',
	DARK_BLUE: 'darkblue',
	PURPLE: 'purple'
});

export const SHAPES = Object.freeze({
	ELLIPSE: 'ellipse',
	LINE: 'line',
	RECTANGLE: 'rectangle'
});

export const SHAPE_ACTIONS = Object.freeze({
	[SHAPES.RECTANGLE]: {
		create(props) {
			return new Rect({ ...props, width: 0, height: 0 });
		},
		resize(shape, left, top, width, height) {
			shape.set({ left, top, width, height });
		}
	},
	[SHAPES.ELLIPSE]: {
		create(props) {
			return new Ellipse({ ...props, rx: 0, ry: 0 });
		},
		resize(shape, left, top, width, height) {
			shape.set({ left, top, rx: width / 2, ry: height / 2 });
		}
	},
	[SHAPES.LINE]: {
		create(props) {
			return new Polyline(
				[
					{ x: props.left, y: props.top },
					{ x: props.left, y: props.top }
				],
				{ stroke: props.stroke, strokeWidth: props.strokeWidth, strokeLineCap: 'round' }
			);
		},
		resize(shape, left, top, width, height) {
			const pointX = left < shape.left ? shape.left - width : shape.left + width;
			const pointY = top < shape.top ? shape.top - height : shape.top + height;

			shape.set({
				points: [
					{ x: shape.left, y: shape.top },
					{ x: pointX, y: pointY }
				],
				width: width * 2,
				height: height * 2
			});
		}
	}
});
